import { Action } from 'redux';
import { UpdateBreadcrumbHref } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';

export interface UpdateBreadcrumbHrefAction extends  Action {
  href: string;
}

export function updateBreadcrumbHref(href: string): UpdateBreadcrumbHrefAction {
  return {
    type: UpdateBreadcrumbHref,
    href
  };
}

export const isUpdateBreadcrumbHrefAction =
  isActionFactory<UpdateBreadcrumbHrefAction>(UpdateBreadcrumbHref);
